import { DeltaPacket } from '@/stores/realtime';
import { ResourceActivity, ResourceActivityResourceType } from '@/types';

export const RESOURCE_ACTIVITY_EVENT = 'countercyclical:resource-activity';

export type ResourceActivityEventAction = 'created' | 'deleted' | 'updated';

export type ResourceActivityDeltaPacket = DeltaPacket<'resourceActivity', ResourceActivity>;

export interface ResourceActivityEventDetail {
    action: ResourceActivityEventAction;
    activity?: ResourceActivity;
    activityId?: string;
    resourceId: string;
    resourceType: ResourceActivityResourceType;
}

export const emitResourceActivityEvent = (detail: ResourceActivityEventDetail) => {
    window.dispatchEvent(new CustomEvent<ResourceActivityEventDetail>(RESOURCE_ACTIVITY_EVENT, { detail }));
};

export const emitResourceActivityDeltaPacket = (packet: ResourceActivityDeltaPacket) => {
    const activity = packet.payload;
    const resourceId = activity?.resourceId;
    const resourceType = activity?.resourceType;

    if (!resourceId || !resourceType) {
        return;
    }

    if (packet.operation === 'delete') {
        emitResourceActivityEvent({
            action: 'deleted',
            activity,
            activityId: packet.entityId,
            resourceId,
            resourceType,
        });

        return;
    }

    emitResourceActivityEvent({
        action: packet.operation === 'update' ? 'updated' : 'created',
        activity,
        resourceId,
        resourceType,
    });
};

export const subscribeResourceActivityEvents = (handler: (detail: ResourceActivityEventDetail) => void) => {
    const listener = (event: Event) => {
        handler((event as CustomEvent<ResourceActivityEventDetail>).detail);
    };

    window.addEventListener(RESOURCE_ACTIVITY_EVENT, listener);

    return () => window.removeEventListener(RESOURCE_ACTIVITY_EVENT, listener);
};
